// Optimized animation variants for smooth, one-time scroll animations
// Using transform-only properties for GPU acceleration

// Smooth easing curve for all animations
const smoothEase = [0.25, 0.1, 0.25, 1];

// Fade in from bottom - most common animation
export const fadeInUp = {
  hidden: { 
    opacity: 0, 
    y: 30,
    willChange: 'opacity, transform'
  },
  visible: { 
    opacity: 1, 
    y: 0,
    willChange: 'auto',
    transition: { 
      duration: 0.5, 
      ease: smoothEase 
    }
  }
};

// Fade in from top
export const fadeInDown = {
  hidden: { 
    opacity: 0, 
    y: -30,
    willChange: 'opacity, transform'
  },
  visible: { 
    opacity: 1, 
    y: 0,
    willChange: 'auto',
    transition: { 
      duration: 0.5, 
      ease: smoothEase 
    }
  }
};

// Fade in from left
export const fadeInLeft = {
  hidden: { 
    opacity: 0, 
    x: -40,
    willChange: 'opacity, transform'
  },
  visible: { 
    opacity: 1, 
    x: 0,
    willChange: 'auto',
    transition: { 
      duration: 0.6, 
      ease: smoothEase 
    }
  }
};

// Fade in from right
export const fadeInRight = {
  hidden: { 
    opacity: 0, 
    x: 40,
    willChange: 'opacity, transform'
  },
  visible: { 
    opacity: 1, 
    x: 0,
    willChange: 'auto',
    transition: { 
      duration: 0.6, 
      ease: smoothEase 
    }
  }
};

// Scale in animation
export const scaleIn = {
  hidden: { 
    opacity: 0, 
    scale: 0.95,
    willChange: 'opacity, transform'
  },
  visible: { 
    opacity: 1, 
    scale: 1,
    willChange: 'auto',
    transition: { 
      duration: 0.5, 
      ease: smoothEase 
    }
  }
};

// Stagger container - controls child animation timing
export const staggerContainer = {
  hidden: { opacity: 1 },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1,
      delayChildren: 0
    }
  }
};

// Stagger item - used with staggerContainer
export const staggerItem = {
  hidden: { 
    opacity: 0, 
    y: 20,
    willChange: 'opacity, transform'
  },
  visible: { 
    opacity: 1, 
    y: 0,
    willChange: 'auto',
    transition: { 
      duration: 0.4, 
      ease: smoothEase 
    }
  }
};

// Timeline item animation - unique staggered reveal
export const timelineItem = (index) => ({
  hidden: { 
    opacity: 0, 
    x: -20,
    willChange: 'opacity, transform'
  },
  visible: { 
    opacity: 1, 
    x: 0,
    willChange: 'auto',
    transition: { 
      duration: 0.5, 
      delay: index * 0.1,
      ease: smoothEase 
    }
  }
});

// Platform card animation - 3D lift effect
export const platformCard = (index) => ({
  hidden: { 
    opacity: 0, 
    y: 40,
    willChange: 'opacity, transform'
  },
  visible: { 
    opacity: 1, 
    y: 0,
    willChange: 'auto',
    transition: { 
      duration: 0.5, 
      delay: index * 0.08,
      ease: smoothEase 
    }
  }
});

// Viewport settings for consistent triggering
export const viewportSettings = {
  once: true,
  amount: 0.2,
  margin: "0px 0px -50px 0px"
};

// Simple fade for basic elements
export const simpleFade = {
  hidden: { 
    opacity: 0,
    willChange: 'opacity'
  },
  visible: { 
    opacity: 1,
    willChange: 'auto',
    transition: { 
      duration: 0.4, 
      ease: smoothEase 
    }
  }
};
